<template>
  <div id="badgeContats">
      <v-container grid-list-md fluid class="pt-0">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search by Date / Family / Source"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card class="mt-1">
          <v-data-table
            :headers="headers"
            :items="BadgeContact"
            :search="search"
            class="pf-data-table" 
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.item.dateFormate }}</td>
              <td>{{ props.item.agency ? props.item.agency.name : '--' }}</td>
              <td>{{ props.item.account ? props.item.account.name : '--' }}</td>
              <td>{{ props.item.contact_name }}</td>
              <td>{{ props.item.source }}{{ props.item.ip ? ('/' + props.item.ip) : '' }}</td>
              <td width="230">{{ props.item.message }}</td>
              <td width="180">{{ props.item.phone ? props.item.phone : '--'}}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.contact_preference }}</td>
              <td align="center">
                <v-switch class="marginTop" @change="changeFollowUp(props.item)" :key="props.item.id" true-value="Yes" false-value="No" v-model="props.item.follow_up"></v-switch>
              </td>
              <td align="right">
                <v-btn icon class="ma-0" v-on:click="deleteItem(props.item);" :title="props.item.deleted_status === true ? 'Removed from agency' : 'Delete'">
                <v-icon v-if="props.item.deleted_status" size="22" color="red">delete</v-icon>
                <v-icon v-else size="22" class="pf-icon-delete">delete_outline</v-icon>
              </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
  </div>
</template>

<script>
/* global session store config  */
import swal from 'sweetalert2';
import { getCollection, formatDate, remove, update } from '../../helpers/helpers';
import { mapGetters } from 'vuex';

// This lists all the countries and allow to edit them.
export default {
  name: 'adminBadgeContacts',
  data: () => ({
    entity: 'BadgeContact',
    search: '',
    headers: [
      { text: 'Date', width: '150px', value: 'date', align: 'left' },
      { text: 'Agency', value: 'agency', align: 'left' },
      { text: 'Family', value: 'account.name', align: 'left' },
      { text: 'Contact', value: 'contact_name', align: 'left' },
      { text: 'Source/IP', value: 'source', align: 'left' },
      { text: 'Message', value: 'message', align: 'left' },
      { text: 'Phone', value: 'phone', align: 'left' },
      { text: 'Email', value: 'email', align: 'left' },
      { text: 'Preference', value: 'contact_preference', align: 'left' },
      { text: 'Follow Up', value: 'follow_up', align: 'left' },
      { text: '', sortable: false },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },  
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    BadgeContact: {
      get () {
        return store.state.BadgeContact;
      },
      set (value) {
        store.commit('setBadgeContact', value);
      }
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    formatDateMethod (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    },
    // @vuese
    // Used to fetch the badge Contact list if not already exists
    async initialize () {
      if (!this.BadgeContact.length) {
        let sort = { createdAt: -1 };
        let { error, data } = await getCollection(this.entity, true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.BadgeContact = data.map(contact => ({ ...contact, dateFormate: this.formatDateMethod(contact.date, 'MM/DD/YYYY') }));
          }
        }
      }
    },
    async changeFollowUp (item) {
      let payload = JSON.parse(JSON.stringify(item));
      delete payload.dateFormate;
      payload.account = item.account.id;
      payload.agency = item.agency.id;
      let { error, data, status } = await update(this.entity, payload, payload.id);
      if (error) {
        console.log('error', error);
      } else {
        data.account = item.account;
        data.agency = item.agency;
        data.dateFormate = item.dateFormate;
        const index = this.BadgeContact.indexOf(item);
        this.BadgeContact.splice(index, 1, data);
        swal.fire(
          'Updated!',
          'Badge Contact "' + item.account.name + '" has been updated.',
          'success'
        );
      }
    },
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.BadgeContact.indexOf(item);
              this.BadgeContact.splice(index, 1);
              swal.fire(
                'Deleted!',
                'Badge Contact"' + item.account.name + '" has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
  }
};
</script>

<style scoped>
 #badgeContats >>> .accent--text {
    color: #019d8c !important;
    caret-color: #019d8c !important;
}

.marginTop >>> .v-input__control {
    margin-top: 25px !important;
}

</style>


// WEBPACK FOOTER //
// src/pages/BadgeContacts/adminList.vue